/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import ProgressNoteDataContent from "components/content/ProgressNoteDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * Clinical progress notes management page.
 * 
 * Features:
 * - List of all clinical progress notes
 * - Note creation with SOAP format support
 * - Patient encounter documentation
 * - Clinical assessment and treatment plan recording
 * - Note filtering by patient, provider, date
 * - Integration with patient medical records
 * - Support for template-based documentation
 * 
 * @returns Progress notes page component
 */
const ProgressNotePage = () => {
  return (
    <DefaultDashboardLayout>
      <ProgressNoteDataContent />
    </DefaultDashboardLayout>
  );
};

export default ProgressNotePage;

